import Vue from 'vue'

const vm = Vue.prototype

/**
 * 数据入口
 */
export const getList = ({ commit }, apiInfo) => {
  vm.$axios.post(apiInfo.url, apiInfo.params)
    .then(({ data: { list } }) => {
      if (!vm.$notNull(list)) {
        list = []
      }
      commit('setSysTableList', list)
    })
}



// WEBPACK FOOTER //
// ./src/store/common/actions.js